// @flow

import * as urls from 'app/urls';
import * as request from 'app/utils/request';
import {gt} from 'app/utils/i18n';
import {limitRequests} from 'app/utils/redux';

import {type CommentContentType, type FilterContentType} from './types';
import {showForbiddenMessageHandler} from 'app/utils/request';

export type CommentsActions = ShowNotificationActionType;

export const loadComments = limitRequests(
  (object_pk: number, content_type: FilterContentType) =>
    (dispatch: Function) => {
      const params = {object_pk, content_type};
      return request
        .get(urls.COMMENTS_API, params)
        .then((data) =>
          dispatch(receiveComments(object_pk, content_type, data))
        )
        .catch(
          request.createErrorHandler(
            gt('Could not load %(content_type)s comments', {content_type}),
            dispatch
          )
        );
    },
  10
);

/* receive comments */

export const RECEIVE_COMMENTS = 'RECEIVE_COMMENTS';

type ShowNotificationActionType = {
  +type: 'RECEIVE_COMMENTS',
  id: number,
  contentType: FilterContentType,
  data: any,
};

export const receiveComments = (
  id: number,
  contentType: FilterContentType,
  data: any
) => ({
  type: RECEIVE_COMMENTS,
  id,
  contentType,
  data,
});

export const deleteComment = (url: string) => (dispatch: any) =>
  request
    .del(url)
    .catch(
      request.createErrorHandler(
        gt('Could not delete the comment'),
        dispatch,
        showForbiddenMessageHandler(false)
      )
    );

export const addComment =
  (
    id: number,
    parentId: number,
    contentType: CommentContentType,
    commentText: string
  ) =>
  (dispatch: Function) =>
    request
      .postJson(urls.COMMENTS_API, {
        content_type: contentType,
        object_pk: id,
        comment: commentText,
      })
      .then(() =>
        dispatch(
          loadComments(parentId, translateCommentContentType(contentType))
        )
      )
      .catch(
        request.createErrorHandler(
          gt('Could not add comment'),
          dispatch,
          request.showNonFieldErrorMessageHandler(
            false,
            gt('Could not add comment')
          )
        )
      );

const translateCommentContentType = (
  contentType: CommentContentType
): FilterContentType =>
  ({
    taskinstance: 'taskinstance',
    procedureversion: 'procedure',
    policyversion: 'policy',
    processversion: 'proceduregroup',
  }[contentType]);
